enum SortVariantsEnum {
  DOWN,
  UP,
  NONE
}

export { SortVariantsEnum }
